import { GestureResponderEvent } from 'react-native'

import { CompleteProfile, RegisterUser } from '@zet/feature-signup'
import { INTENT } from '@zet/utils/Constants'

type IntentTriggerBottomSheetProps = {
  isVisible: boolean
  intent: string
  setIsVisible: (x: boolean) => void
  handleOnPress: (args: GestureResponderEvent) => void
}
export function IntentTriggerBottomSheet({
  isVisible,
  intent,
  setIsVisible,
  handleOnPress,
}: IntentTriggerBottomSheetProps) {
  return (
    <>
      {intent === INTENT.HIGH && (
        <RegisterUser
          isVisible={isVisible}
          setIsVisible={setIsVisible}
          handleOnPress={handleOnPress}
        />
      )}

      {intent === INTENT.LOW && (
        <CompleteProfile isVisible={isVisible} setIsVisible={setIsVisible} />
      )}
    </>
  )
}
